import { render, staticRenderFns } from "./DashboardFeedbacks.vue?vue&type=template&id=77b7da26&scoped=true"
import script from "./DashboardFeedbacks.vue?vue&type=script&lang=js"
export * from "./DashboardFeedbacks.vue?vue&type=script&lang=js"
import style0 from "./DashboardFeedbacks.vue?vue&type=style&index=0&id=77b7da26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b7da26",
  null
  
)

export default component.exports